interface SupabaseViteEnv {
  VITE_SUPABASE_ANON_KEY?: string;
  VITE_SUPABASE_PUBLISHABLE_KEY?: string;
}

interface SupabaseExpoEnv {
  EXPO_PUBLIC_SUPABASE_ANON_KEY?: string;
  EXPO_PUBLIC_SUPABASE_PUBLISHABLE_KEY?: string;
}

export function firstNonEmpty(
  ...values: Array<string | undefined>
): string | undefined {
  return values.find((value) => value?.trim());
}

export function resolveSupabasePublishableKey(
  env: SupabaseViteEnv,
): string | undefined {
  return firstNonEmpty(
    env.VITE_SUPABASE_PUBLISHABLE_KEY,
    env.VITE_SUPABASE_ANON_KEY,
  );
}

export function resolveExpoSupabasePublishableKey(
  env: SupabaseExpoEnv,
): string | undefined {
  return firstNonEmpty(
    env.EXPO_PUBLIC_SUPABASE_PUBLISHABLE_KEY,
    env.EXPO_PUBLIC_SUPABASE_ANON_KEY,
  );
}
